import { hasMinRole, UserRoleUI } from "../../constants/rolesAndPermissions";

export const CONNECTOR_NO_ACCESS = "NO_ACCESS" as const;

export type ConnectorAccessSelection = UserRoleUI | typeof CONNECTOR_NO_ACCESS;

export const CONNECTOR_ROLE_OPTIONS: readonly UserRoleUI[] = Object.values(UserRoleUI);

export const getEnabledRolesForMinimumRole = (minimumRole: UserRoleUI): UserRoleUI[] =>
  CONNECTOR_ROLE_OPTIONS.filter((role) => hasMinRole(role, minimumRole));

export const getMinimumRoleForEnabledRoles = (enabledRoles: readonly string[]): UserRoleUI | null =>
  CONNECTOR_ROLE_OPTIONS.find((role) => enabledRoles.includes(role)) ?? null;

export const connectorAllowsUserRole = (enabledRoles: readonly string[], userRole: UserRoleUI): boolean =>
  enabledRoles.includes(userRole);

export const getEnabledRolesForAccessSelection = (selection: ConnectorAccessSelection): UserRoleUI[] => {
  if (selection === CONNECTOR_NO_ACCESS) {
    return [];
  }

  return getEnabledRolesForMinimumRole(selection);
};

export const getConnectorAccessSelection = (enabledRoles: readonly string[]): ConnectorAccessSelection =>
  getMinimumRoleForEnabledRoles(enabledRoles) ?? CONNECTOR_NO_ACCESS;
